import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReferentialKey } from "api/referential";
import { referentialsApi } from "services/swagger-api/referentialsAPI";

export const getMultipleReferentialsByKeys = createAsyncThunk(
  'subscriptionProcess/getMultipleReferentialsByKeys',
  async (referentialKeys: ReferentialKey[]) => {
    const response = await referentialsApi.getMultipleReferentials({
      getReferentialsByKeysCommand: { referentialKeys }
    });
    return response;
  }
);
